













import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class Dialog extends Vue {
  @Prop()
  private title!: string

  @Prop()
  private content!: string

  private show: boolean = false

  public open() {
    this.show = true
  }

  public close() {
    this.show = false
  }
}
